export default "__VITE_ASSET__OU6PIKS$__"